import React from "react";
import { connect } from "react-redux";
import { getTranslate } from "react-localize-redux";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
  Button,
} from "reactstrap";
import axios from "axios";
import moment from "moment";
import { isIE } from "react-device-detect";
import ReactJson from "react-json-view";
import ReactTooltip from "react-tooltip";

import { configActions } from "../../../../../redux/actions";
import { WizardFormSecondPage } from "../../../../../components/NewReportWizard";
import { RunTestReport } from "../../runTestReport";
import { CopyNewConfigReport } from "./CopyNewConfigReport";

class EditConfigReport extends React.Component {
  state = {
    modalHistory: false,
    selectedHistory: [],

    fullEventModal: false,
    eventJsonObj: {},
    msg: {},
    invalidFtpConfirmModal: false,
    //savingReport: false,

    showMoreDesc: false,
    moreMenuOpen: false,
  };

  toggleMoreMenu = () => {
    this.setState({
      moreMenuOpen: !this.state.moreMenuOpen,
    });
  };

  closeWindow = () => {
    this.props.dispatch(configActions.toggleEditConfigReportModal(false));
  };

  toggleModalHistory = () => {
    this.setState({
      modalHistory: !this.state.modalHistory,
    });
  };

  handleHistoryClick = () => {
    const { reportForEdit } = this.props;
    if (reportForEdit) {
      let params = {
          originalobjectid: reportForEdit._id,
        },
        me = this;
      axios
        .get("Configuration/history/byoriginalid", { params: params })
        .then((response) => {
          me.setState({
            modalHistory: true,
            selectedHistory: response.data.Data,
          });
        });
    }
  };

  handleOpenFullEventClick = (dataObject) => {
    if (dataObject) {
      this.setState({
        eventJsonObj: dataObject,
        fullEventModal: true,
      });
    }
  };

  toggleFullEventModal = () => {
    this.setState({
      fullEventModal: !this.state.fullEventModal,
    });
  };

  handleSaveClick = () => {
    const { reportForEdit, reportForEditDef, handleFormSave } = this.props;
    const formState = this.inputFormWiz.state;
    var me = this;
    const {
      ftpDeliveryState,
      sftpDeliveryState,
      ftpHost,
      ftpPort,
      ftpUserName,
      ftpUserPassword,
      ftpUploadPath,
    } = formState;

    if (ftpDeliveryState || sftpDeliveryState) {
      let transportItems = null;
      if (
        reportForEdit &&
        reportForEdit.reportDefComponentsParams &&
        reportForEdit.reportDefComponentsParams.length
      ) {
        transportItems =
          reportForEdit.reportDefComponentsParams[1] &&
          reportForEdit.reportDefComponentsParams[1].data &&
          reportForEdit.reportDefComponentsParams[1].data.transportitems;
      }
      var ftpDeliveryStateOld,
        sftpDeliveryStateOld,
        ftpHostOld,
        ftpPortOld,
        ftpUserNameOld,
        ftpUserPasswordOld,
        ftpUploadPathOld;
      if (transportItems && transportItems.length) {
        transportItems.forEach((item, index) => {
          if (item.type === "Ftp") {
            ftpDeliveryStateOld = true;
            sftpDeliveryStateOld = false;
            ftpHostOld = item.host;
            ftpPortOld = item.port;
            ftpUserNameOld = item.username;
            ftpUserPasswordOld = item.password;
            ftpUploadPathOld = item.path;
          } else if (item.type === "Sftp") {
            ftpDeliveryStateOld = false;
            sftpDeliveryStateOld = true;
            ftpHostOld = item.host;
            ftpPortOld = item.port;
            ftpUserNameOld = item.username;
            ftpUserPasswordOld = item.password;
            ftpUploadPathOld = item.path;
          }
        });
      }

      if (ftpHost && ftpPort && ftpUserName && ftpUserPassword) {
        if (
          ftpDeliveryStateOld !== ftpDeliveryState ||
          sftpDeliveryStateOld !== sftpDeliveryState ||
          ftpHostOld !== ftpHost ||
          ftpPortOld !== ftpPort ||
          ftpUserNameOld !== ftpUserName ||
          ftpUserPasswordOld !== ftpUserPassword ||
          ftpUploadPathOld !== ftpUploadPath
        ) {
          var params = {
            IsSFTP: sftpDeliveryState,
            Host: ftpHost,
            Port: ftpPort,
            Username: ftpUserName,
            Password: ftpUserPassword,
            Path: ftpUploadPath,
          };
          axios
            .post("Reporting/Pipelines/checkftpsftpconnection", params)
            .then((response) => {
              if (response.data.Errors && response.data.Errors.length) {
                // confirmation window
                me.setState({
                  invalidFtpConfirmModal: true,
                });
              } else {
                // save without asking...
                handleFormSave(
                  {
                    ...formState,
                    //isActive: this.state.isActive
                  },
                  reportForEditDef,
                  reportForEdit
                  //me.resetLoader
                );
              }
            });
        } else {
          handleFormSave(
            {
              ...formState,
              //isActive: this.state.isActive
            },
            reportForEditDef,
            reportForEdit
            //me.resetLoader
          );
        }
      } else {
        this.setState({
          //savingReport: false,
          msg: {
            header: "FTP/SFTP Check",
            message: (
              <Alert style={{ width: "650px" }} color="danger">
                The following fields are required for FTP/SFTP delivery
                configuration:
                <br />
                Host, Port, Username, and Password.
              </Alert>
            ),
          },
        });
      }
    } else {
      handleFormSave(
        {
          ...formState,
          //isActive: this.state.isActive
        },
        reportForEditDef,
        reportForEdit
        //this.resetLoader
      );
    }
  };

  /* resetLoader = () => {
		this.setState({
			savingReport: false
		});
	}; */

  toggleMsgBox = () => {
    this.setState({
      msg: {},
    });
  };

  toggleInvalidFtpConfirmModal = () => {
    this.setState({
      invalidFtpConfirmModal: !this.state.invalidFtpConfirmModal,
    });
  };
  handleYesConfirmInvalidFtpDialog = () => {
    const { reportForEditDef, reportForEdit, handleFormSave } = this.props;
    const formState = this.inputFormWiz.state;
    handleFormSave(
      {
        ...formState,
        //isActive: this.state.isActive
      },
      reportForEditDef,
      reportForEdit
      //this.resetLoader
    );
    this.setState({
      invalidFtpConfirmModal: false,
    });
  };
  handleNoConfirmInvalidFtpDialog = () => {
    this.setState({
      savingReport: false,
      invalidFtpConfirmModal: false,
    });
  };

  toggleShowMoreDesc = (showMoreDesc) => {
    this.setState({
      showMoreDesc: showMoreDesc,
    });
  };

  handleCopyClick = () => {
    const {
      reportForEdit,
      reportForEditDef,
      user,
      subUser,
      isSubUser,
      dispatch,
    } = this.props;
    let _report = JSON.parse(JSON.stringify(reportForEdit));
    const { reportDefComponentsParams } = _report;
    if (
      reportDefComponentsParams &&
      reportDefComponentsParams.length &&
      reportDefComponentsParams[0].data
    ) {
      let _newRepDefCompParams = [...reportDefComponentsParams];
      let currentUser = user;
      if (isSubUser) {
        currentUser = subUser;
      }
      const copySuffixText = ` (copy by ${currentUser?.userId})`;
      _newRepDefCompParams[0].data.reportName =
        (_newRepDefCompParams[0].data?.reportName || "") + copySuffixText;
      _report = { ..._report, reportDefComponentsParams: _newRepDefCompParams };
    }
    dispatch(
      configActions.toggleCopyNewConfigReportModal(
        true,
        _report,
        reportForEditDef
      )
    );
  };

  tooltipOverridePosition = ({ left, top }) => {
    if (isIE) {
      const vw = Math.max(
        document.documentElement.clientWidth || 0,
        window.innerWidth || 0
      );
      left = left + vw / 2 - 375;
      top = top + 25;
    }
    return { top, left };
  };
  render() {
    const {
      reportForEdit,
      modalCopyNewConfigReport,
      //selectedCustomerGlobalId,
      reportForEditDef,
      modalEditConfigReport,
      handleActiveChange,
      handleInternalUseChange,
      isActive,
      internalUse,
      translate,
      isSubUser,
    } = this.props;
    var inputData =
      ((this.inputFormWiz || {}).state || {}).params ||
      (
        (
          (((reportForEdit || {}).reportDefComponentsParams || {})[0] || {})
            .data || {}
        ).scriptparams || {}
      ).inputData ||
      {};
    return (
      <Modal
        style={
          this.state.showMoreDesc
            ? { maxWidth: "unset" }
            : { maxWidth: "750px" }
        }
        isOpen={modalEditConfigReport}
      >
        <div className="modal-header">
          <h5 className="modal-title">{translate("Edit configured report")}</h5>
          <div
            className="active-wizard"
            style={{ textAlign: "end", margin: "0 1em 0 0", flex: 1 }}
          >
            <input
              type="checkbox"
              id="isActiveReport"
              checked={isActive}
              style={{ margin: "5px" }}
              onChange={handleActiveChange}
            />
            <label
              htmlFor="isActiveReport"
              style={{ marginTop: "3px" }}
              className="form-check-label"
            >
              {translate("Active")}
            </label>
          </div>
          {!isSubUser && (
            <div className="active-wizard">
              <input
                type="checkbox"
                id="internalUse"
                checked={internalUse}
                style={{ margin: "5px" }}
                onChange={handleInternalUseChange}
              />
              <label
                htmlFor="internalUse"
                style={{ marginTop: "3px" }}
                className="form-check-label"
              >
                {translate("Internal use only")}
              </label>
            </div>
          )}
          <button
            type="button"
            onClick={this.closeWindow}
            className="close"
            aria-label="Close"
          >
            <span aria-hidden="true">{String.fromCharCode(215)}</span>
          </button>
        </div>
        <ModalBody style={{ backgroundColor: "#d9d9d9", padding: "1px" }}>
          <WizardFormSecondPage
            ref={(inputFormWiz) => {
              this.inputFormWiz = inputFormWiz;
            }}
            channels={this.props.channels}
            customers={this.props.customers}
            availableTimeZones={this.props.availableTimeZones}
            user={this.props.user}
            subUser={this.props.subUser}
            isSubUser={this.props.isSubUser}
            translate={translate}
            selectedReportType={reportForEditDef}
            selectedReport={reportForEdit}
            toggleShowMoreDesc={this.toggleShowMoreDesc}
            showMoreDesc={this.state.showMoreDesc}
            isActive={isActive}
          />
        </ModalBody>
        <ModalFooter style={{ display: "flex" }}>
          <div
            className="text-center"
            style={{ flex: 1, fontSize: "11px", fontWeight: "bold" }}
          >
            <span>{translate("LastUpdate")}: </span>
            <span>
              {(reportForEdit && reportForEdit.modifiedByUser) ||
                (reportForEdit && reportForEdit.createdByUser) ||
                translate("unknown")}
              ,{" "}
            </span>
            <span>
              {reportForEdit && reportForEdit.modified
                ? moment
                    .utc(reportForEdit.modified, moment.ISO_8601)
                    .format("YYYY.MM.DD HH:mm")
                : reportForEdit && reportForEdit.created
                ? moment
                    .utc(reportForEdit.created, moment.ISO_8601)
                    .format("YYYY.MM.DD HH:mm")
                : "n/a"}
            </span>
            {!isSubUser && (
              <button
                className="add-issue-btn"
                data-tip
                data-place="bottom"
                data-type="info"
                data-effect="solid"
                data-for="editHistoryBtn"
                onClick={this.handleHistoryClick}
              >
                <i className="fa fa-history" style={{ padding: "0 10px" }} />
              </button>
            )}
            <ReactTooltip
              className="customeTheme"
              id="editHistoryBtn"
              overridePosition={this.tooltipOverridePosition}
            >
              <strong>{translate("History")}</strong>
            </ReactTooltip>
            <button
              type="button"
              disabled={this.state.savingReport}
              className="btn btn-secondary"
              style={{ marginLeft: "15px" }}
              onClick={this.closeWindow}
            >
              {translate("Close")}
            </button>
            <button
              type="button"
              disabled={this.state.savingReport}
              className="btn btn-primary"
              style={{ marginLeft: "15px" }}
              onClick={this.handleSaveClick}
            >
              {translate("Save")}
            </button>
            <RunTestReport
              reportDefinitionId={this.props.reportDefinitionId}
              reportPipelineDefinitionId={this.props.reportPipelineDefinitionId}
              customerId={inputData.customer}
              project={inputData.project}
              projects={inputData.projects}
              channel={inputData.channel}
              timezone={inputData.timezone}
              disabled={this.state.savingReport}
              closeParentModal={this.closeWindow}
            />
            {this.state.savingReport && (
              <img
                alt=""
                style={{ padding: "12px 12px" }}
                src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA=="
              />
            )}
          </div>
          <div>
            <button
              className="add-issue-btn"
              style={{ marginTop: "3px" }}
              data-tip
              data-place="left"
              data-type="info"
              data-effect="solid"
              data-for="editCloneBtn"
              onClick={this.handleCopyClick}
            >
              <i
                className="fa fa-clone"
                style={{ padding: "0 10px", fontSize: "1.3em" }}
              />
            </button>
            <ReactTooltip
              className="customeTheme"
              id="editCloneBtn"
              overridePosition={this.tooltipOverridePosition}
            >
              <strong>{translate("Clone")}</strong>
            </ReactTooltip>
          </div>
        </ModalFooter>
        <Modal
          isOpen={this.state.modalHistory}
          toggle={this.toggleModalHistory}
        >
          <ModalHeader toggle={this.toggleModalHistory}>
            {translate("History")}
          </ModalHeader>
          <ModalBody>
            <div className="table w_subsearch_res_body">
              <div className="tr th">
                <div className="td" style={{ flexGrow: "3" }}>
                  {translate("Date")}
                </div>
                <div className="td" style={{ flexGrow: "3" }}>
                  {translate("Username")}
                </div>
                <div className="td">&nbsp;</div>
              </div>
              {this.state.selectedHistory &&
                this.state.selectedHistory.length > 0 &&
                this.state.selectedHistory.map((row, i) => {
                  return (
                    <div key={i} className="tr">
                      <div className="td" style={{ flexGrow: "3" }}>
                        <div className="w_subsearch_res_text">
                          <span style={{ marginLeft: "4px" }}>
                            {row.creationDate
                              ? moment
                                  .utc(row.creationDate, moment.ISO_8601)
                                  .format("DD-MM-YYYY HH:mm:ss")
                              : "n/a"}
                          </span>
                        </div>
                      </div>
                      <div className="td" style={{ flexGrow: "3" }}>
                        <div
                          className="w_subsearch_res_text"
                          data-container="body"
                        >
                          {row.author}
                        </div>
                      </div>
                      <div className="td">
                        <div
                          className="w_subsearch_res_text"
                          role="button"
                          data-container="body"
                        >
                          <button
                            onClick={(e) => {
                              this.handleOpenFullEventClick(row.dataObject);
                            }}
                            style={{ padding: "1px 6px" }}
                            className="btn btn-default btn-xs w_p_action_sub"
                            title="Data object"
                          >
                            <span
                              className="fa fa-folder-open"
                              aria-hidden="true"
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              {this.state.selectedHistory.length === 0 && (
                <div className="tr">
                  <div
                    className="td justify-content-center"
                    style={{ flexGrow: "2" }}
                  >
                    <span>{translate("NoResults")}</span>
                  </div>
                </div>
              )}
            </div>
          </ModalBody>
          <ModalFooter className="text-center">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={this.toggleModalHistory}
            >
              {translate("Close")}
            </button>
          </ModalFooter>
        </Modal>
        <Modal
          style={{ width: "70vw", maxWidth: "95vw" }}
          isOpen={this.state.fullEventModal}
          toggle={this.toggleFullEventModal}
        >
          <ModalHeader toggle={this.toggleFullEventModal}>Details</ModalHeader>
          <ModalBody>
            <ReactJson
              src={this.state.eventJsonObj}
              enableClipboard
              displayDataTypes={false}
            />
          </ModalBody>
        </Modal>
        <Modal
          isOpen={!!this.state.msg.message}
          style={{ maxWidth: "700px", maxHeight: "700px" }}
          toggle={this.toggleMsgBox}
        >
          {this.state.msg.header && (
            <ModalHeader toggle={this.toggleMsgBox}>
              {this.state.msg.header}
            </ModalHeader>
          )}
          <ModalBody>{this.state.msg.message}</ModalBody>
          <ModalFooter className="text-center">
            <Button
              color="primary"
              className="switchBtn"
              style={{ width: "100px" }}
              onClick={this.toggleMsgBox}
            >
              {translate("OK")}
            </Button>
          </ModalFooter>
        </Modal>
        <Modal
          isOpen={this.state.invalidFtpConfirmModal}
          toggle={this.toggleInvalidFtpConfirmModal}
        >
          <ModalHeader toggle={this.toggleInvalidFtpConfirmModal}>
            {translate("FTP_FTP Connection Checking")}
          </ModalHeader>
          <ModalBody>
            <Alert color="warning">
              {translate("FTP_SFTP checking failed")}"
            </Alert>
          </ModalBody>
          <ModalFooter className="text-center">
            <Button
              color="secondary"
              style={{ width: "90px" }}
              onClick={this.handleYesConfirmInvalidFtpDialog}
            >
              {translate("Yes")}
            </Button>
            <Button
              color="primary"
              className="EventSearchSubmit"
              style={{ marginLeft: "60px", width: "90px" }}
              onClick={this.handleNoConfirmInvalidFtpDialog}
            >
              {translate("No")}
            </Button>
          </ModalFooter>
        </Modal>
        {modalCopyNewConfigReport && (
          <CopyNewConfigReport
            isActive={this.props.isActive}
            isExternalUser={this.props.isSubUser}
            internalUse={this.props.internalUse}
            closeParentModal={this.closeWindow}
            handlePageReload={this.props.handlePageReload}
          />
        )}
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  const {
    config: {
      reportForEdit,
      modalCopyNewConfigReport,
      selectedCustomerGlobalId,
      reportForEditDef,
      modalEditConfigReport,
      customers,
      channels,
    },
    locale,
    authentication,
    settings: { availableTimeZones },
  } = state;
  const { user, subUser, isSubUser } = authentication;
  return {
    reportForEdit,
    modalCopyNewConfigReport,
    selectedCustomerGlobalId,
    reportForEditDef,
    modalEditConfigReport,
    customers,
    channels,
    availableTimeZones,
    user,
    subUser,
    isSubUser,
    translate: getTranslate(locale),
  };
}

const connectedEditConfigReport = connect(mapStateToProps)(
  React.memo(EditConfigReport)
);
export { connectedEditConfigReport as EditConfigReport };
